// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"52047fac","787":"8ebc37a6"}[chunkId] + ".chunk.js";
};